import React from "react"
import {Amplify, I18n} from 'aws-amplify';
import {Authenticator, AmplifyProvider} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import awsExports from '../../aws-exports';
import {swedishTranslation} from "./swedish";

Amplify.configure(awsExports)

I18n.putVocabulariesForLanguage('sv', swedishTranslation)
I18n.setLanguage('sv');

type ProtectedPageProps = {
  children: React.ReactNode
}

const ProtectedPage = (props: ProtectedPageProps) =>
  <AmplifyProvider>
    <div className="pa3">
      <Authenticator>
        {() => <>{props.children}</>}
      </Authenticator>
    </div>
  </AmplifyProvider>

export default ProtectedPage
